import { z } from "zod";

export const copyTicketSchema = z.object({
	type: z.string().nonempty(),
});
